import { Modal, Paper, Typography } from '@material-ui/core'
import React from 'react'

import { getDirection, getTranslate } from '../../../localization'
import JsonViewer from './JsonViewer'
import useStyles from './styles/index.styles'

interface ContentModalProps {
  onClose: () => void
  data: object
}

const ResultModal: React.FC<ContentModalProps> = ({ onClose, data }) => {
  const classes = useStyles()

  return (
    <Modal open dir={getDirection()} onClose={onClose}>
      <Paper className={classes.modalPaper}>
        <Typography className={classes.contentTitlesHeader} variant="h2">
          {getTranslate('Result Info')}
        </Typography>
        <div className={classes.contentInfoContainerWrapper}>
          <div className={classes.contentInfoContainer}>
            <JsonViewer jsonData={data} openForResult />
          </div>
        </div>
      </Paper>
    </Modal>
  )
}

export default ResultModal
